import { CALLING} from '../apiConstant';
import BaseApi from '../baseApi';

class CallingApi extends BaseApi {
    sendRequest(param) {
        return this.post(`${CALLING}/request`,param);
    }
}
export default CallingApi;
